export default __webpack_public_path__ + "static/media/Steward_Particle_0000_Layer-75.e52da20d.png";